import { render, staticRenderFns } from "./PwdResetSendForm.vue?vue&type=template&id=3dee601a&"
import script from "./PwdResetSendForm.vue?vue&type=script&lang=ts&"
export * from "./PwdResetSendForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports